import { createPolicy } from "../base-policy/base-policy";
import type { ConfigOptions, Hooks } from "./domPurify-config";
import { sanitizedHTMLAndValidate } from "./domPurify-utils";

/**
 * Creates a Trusted Types Policy using DOMPurify library to sanitize HTML content.
 * @param {string} policyName - The name of the policy. Should be unique.
 * @param {TrustedTypesPolicyFactory} [trustedTypesApi] - Optional trusted types API. Given that it is only available in the browser, we should specify one for unit testing.
 * @returns {TrustedHTML} The DOMPurifyPolicy for HTML.
 */
export const createDomPurifyPolicyHtml = (
  policyName: string,
  trustedTypesApi?: any
) => {
  return createPolicy(
    policyName,
    {
      /**
       * @param {string} unsanitizedHTML - String HTML that will be return sanitized and as Trusted Type
       * @param {ConfigOptions} config - optional configuration for sanitize method.
       * @param {Hooks} hooks - optional hooks to be applied during sanitization.
       * @returns {TrustedHTML} The DOMPurifyPolicy for HTML.
       */
      createHTML: (html: string, config?: ConfigOptions, hooks?: Hooks) =>
        sanitizedHTMLAndValidate(html, config, hooks),
    },
    trustedTypesApi
  );
};

/**
 * Production dom purify policy for HTML.
 */
// eslint-disable-next-line
export const domPurifyPolicyHtml =
  /*#__PURE__*/ createDomPurifyPolicyHtml("domPurifyHTML");
